<nb-card class="lista-crud">
  <nb-card-header class="head">
    <div class="titulo-bloco">
      <span class="titulo-principal">Usuários</span>
    </div>
    <button nbButton status="primary" size="medium" class="btn-primario-crud" (click)="novo()">
      <nb-icon pack="eva" icon="person-add-outline" class="icone-primario-crud"></nb-icon>
      <span>Novo usuário</span>
    </button>
  </nb-card-header>

  <nb-card-body>
    <div class="smart-toolbar">
      <div class="filtro-toolbar-inline">
        <div class="filtro-turma-full">
          <label class="field-label" for="usuarioBusca">Busca</label>
          <nb-form-field>
            <nb-icon nbPrefix pack="eva" icon="search-outline"></nb-icon>
            <input
              nbInput
              fullWidth
              id="usuarioBusca"
              type="text"
              autocomplete="off"
              placeholder="Nome ou login — Enter para buscar"
              name="usuarioFiltro"
              [(ngModel)]="filtro"
              (keyup.enter)="buscarAgora()"
            />
          </nb-form-field>
        </div>
        <div class="campo-filtro--acoes">
          <button nbButton status="basic" size="small" type="button" (click)="buscarAgora()" title="Buscar agora" aria-label="Buscar agora">
            <nb-icon pack="eva" icon="search-outline"></nb-icon>
          </button>
        </div>
      </div>
    </div>

    <app-barra-carregando *ngIf="carregando"></app-barra-carregando>
    <div class="smart-table-wrap" *ngIf="usuarios.length">
      <table class="smart-table">
        <thead>
          <tr>
            <th appOrdenavel campo="nome" rotuloAcessivel="Nome" [ordenacao]="ordenacao" (ordenar)="ordenarPor($event)">Nome</th>
            <th appOrdenavel campo="login" rotuloAcessivel="Login" [ordenacao]="ordenacao" (ordenar)="ordenarPor($event)">Login</th>
            <th appOrdenavel campo="cpf" rotuloAcessivel="CPF" [ordenacao]="ordenacao" (ordenar)="ordenarPor($event)">CPF</th>
            <th>Perfis</th>
            <th class="col-acoes col-acoes--icones">Ações</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let u of usuarios">
            <td data-label="Nome">{{ u.nome }}</td>
            <td data-label="Login">{{ u.login }}</td>
            <td data-label="CPF">{{ u.cpf || '—' }}</td>
            <td data-label="Perfis">{{ perfilLabels(u) }}</td>
            <td class="col-acoes col-acoes--icones" data-label="Ações">
              <div class="acao-btns acao-btns--inline" role="group">
                <button
                  type="button"
                  nbButton
                  size="small"
                  appearance="outline"
                  status="info"
                  class="btn-acao"
                  (click)="editar(u)"
                  title="Editar"
                  aria-label="Editar usuário"
                >
                  <nb-icon pack="eva" icon="edit-outline"></nb-icon>
                </button>
              </div>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
    <app-lista-vazia
      *ngIf="!usuarios.length"
      icone="settings-2-outline"
      [filtrado]="temFiltro"
      mensagem="Nenhum usuário cadastrado ainda."
      mensagemFiltrado="Nenhum usuário casa com o recorte atual."
      acaoCriarRotulo="Cadastrar usuário"
      (criar)="novo()"
      (verTodos)="limparFiltro()"
    ></app-lista-vazia>

    <div class="lista-paginacao" *ngIf="totalPages > 0">
      <button nbButton size="small" [disabled]="page === 1" (click)="onPageChange(page - 1)">Anterior</button>
      <span>Página {{ page }} de {{ totalPages }}</span>
      <button nbButton size="small" [disabled]="page === totalPages" (click)="onPageChange(page + 1)">Próxima</button>
    </div>
  </nb-card-body>
</nb-card>
